<template>
  <section class="chat-body mt">
    <h2 class="mb">Welcome!</h2>

    <p>This chatbot uses artificial intelligence to help answer your support questions.</p>
    <p>
      Responses may be incorrect, incomplete, or outdated, so please verify important information before making
      decisions.
    </p>
    <p>
      Usage metrics may be collected to help improve the service. Personally identifiable information is not collected.
    </p>
    <p>Please accept to begin your chat session.</p>

    <div class="chat-bottom-btn">
      <button class="btn-primary" @click="chatBotStore.acceptedTerms = true">I accept</button>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useChatBotStore } from "../stores/chatBotStore";

const chatBotStore = useChatBotStore();
</script>
